import React, { useCallback } from "react";
import List from "@commonComponents/List";
import AddGuaranteeDetailsForm from "@EUForms/addGuaranteeDetailsForm";
import { useSelector } from "react-redux";
import { selectCurrencyCodesList,selectCustomOfficeList } from "@EUForms/selectors";


const addGuaranteeDetail = ({dataSource,...rest}) => {
   const currencyList=useSelector(selectCurrencyCodesList)
   const customOfficeList=useSelector(selectCustomOfficeList)
  const renderItem=useCallback((item)=> <AddGuaranteeDetailsForm 
  dataSource={item} 
  key={item.id} 
  currencyList={currencyList}
  guaranteeOfficeList={customOfficeList}
  {...rest} />,[currencyList,customOfficeList,rest]
)

  
  return  <List className="responsiveGridCss" dataSource={dataSource} renderItem={renderItem} />
}

export default React.memo(addGuaranteeDetail)
